import { getUrlParameterValue } from "./url"

const tracking_codes = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content', "gclid", "idads", "_gl", "clickid"]

export function setCookie(name, value, exdays) {
  const d = new Date();
  let expires = "";
  if (exdays > 0) {
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    expires = "expires=" + d.toUTCString() + ";";
  }
  document.cookie = name + "=" + value + ";" + expires + "path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function saveTrackingCookies() {
  tracking_codes.forEach(code => {
    const value = getUrlParameterValue(code)
    if (value) {
      setCookie("f_" + code, value, -1)
    }
  })

  if (window.location.search !== "") {
    setCookie("f_tracking_params", window.location.search, -1)
  }
}

export function getTrackingCookies() {
  let extracted = {}
  tracking_codes.forEach(utm => {
    const value = getCookie("f_" + utm)
    if (value && value !== "") {
      extracted[utm] = getCookie("f_" + utm)
    } else {
      extracted[utm] = ""
    }
  })
  return extracted
}